import React, { FC } from "react";
import svgIcons from "../assets/svg/svgIcons";

interface AccordianProps {
  wrapperClassName?: string;
  title: string;
  children: React.ReactNode;
  isOpen?: boolean;
  setIsOpen?: (isOpen: boolean) => void;
  collapsible?: boolean;
  showButton?: boolean;
  isLoading?: boolean;
  titleSize?: string;
  border?: boolean;
  buttonDimensionClass?: string;
  buttonLeadingClass?: string;
}

const AccordianWithOptions: FC<AccordianProps> = ({
  wrapperClassName = "",
  title,
  children,
  isOpen = false,
  setIsOpen = () => {},
  showButton = true,
  isLoading = false,
  titleSize = "lg",
  border = true,
  buttonDimensionClass = "px-5 py-[10px]",
  buttonLeadingClass = "leading-10",
}) => {
  return (
    <div className={wrapperClassName}>
      {showButton && (
        <button
          type="button"
          className={`w-full ${buttonDimensionClass} flex items-center ${border && "border-b border-b-slate-300"} cursor-pointer hover:bg-accent-blue-paleO66`}
          onClick={() => setIsOpen(!isOpen)}
        >
          <div
            className={`flex-grow flex justify-between items-center text-left text-lg font-semibold ${buttonLeadingClass} tracking-tight text-accent-blue-dark`}
          >
            {/* <span>{title}</span> */}
            <div
              className={`flex-grow text-left text-${titleSize} font-semibold ${buttonLeadingClass} tracking-tight ${titleSize === "lg" && "text-accent-blue-dark"}`}
            >
              {title}
            </div>
            <img
              src={isOpen ? svgIcons.CollapseIcon : svgIcons.ExpandMoreIcon}
              alt="expand-more-icon"
              className="grayscale"
            />
            {isLoading && (
              <img
                src={svgIcons.LoadingAnimation}
                alt="loading-animation"
                className="w-6 h-6"
              />
            )}
          </div>
          {/* <div
            className={`flex-grow text-left text-${titleSize} font-semibold leading-10 tracking-tight ${titleSize === "lg" && "text-accent-blue-dark"}`}
          >
            {title}
          </div>
          <img
            src={isOpen ? svgIcons.CollapseIcon : svgIcons.ExpandMoreIcon}
            alt="expand-more-icon"
            className="grayscale"
          /> */}
        </button>
      )}
      {isOpen && <>{children}</>}
    </div>
  );
};

export default AccordianWithOptions;
